<template>
    <div>
        <top-navbar :padding="topPadding"></top-navbar>

        <div class="container-fluid mt--6">

            <div class="pt-5" v-show="hasNotice">
                <app-status :remote-version="appVersion" @show="appStatus = true"></app-status>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <user-card :user="learner"></user-card>
                </div>
                <div class="col-md-8">
                    <registrations :registrations="registrations" :learner="learner"></registrations>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import UserCard from '../auth/components/UserCard'
    import Registrations from './learner/Registrations';
    import AppStatus from './offline/AppStatus';

    export default {

        components: {
            UserCard, Registrations, AppStatus
        },

        data() {
            return {
                appStatus: false,
                learner: {},
                registrations: null,
            }
        },

        computed: {

            appVersion() {
                return this.$auth['config'].app_version
            },

            hasNotice() {
                return this.appStatus
            },

            topPadding() {
                return this.hasNotice ? 4 : 6
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            to.params.learnerId = Vue.prototype.$auth.user.id
            axios.get('/astral/api/front/dashboard/learners/'+to.params.learnerId+'/registrations')
            .then(resp => {
                next(vm => {
                    vm.registrations = resp.data.data
                    vm.learner = resp.data.included.learner
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
